import { toCamelCaseObj } from '@utils';
import { CamelCasedObject } from '../types/camelCaseObject';
import { RAuthProfileAPIResponse } from '../types/user';
import { AuthEndpoints, authFetcher } from './fetchers';

export async function getMyProfile() {
  const response = await authFetcher.get<
    CamelCasedObject<RAuthProfileAPIResponse>
  >(AuthEndpoints.myProfile);
  let profile = { ...response?.data?.data, poa: false };
  if (profile?.readOnly && ['pl', 'hdfc'].includes(profile?.currentBroker)) {
    profile = { ...profile, readOnly: false, poa: true };
  }
  return toCamelCaseObj(profile);
}

export async function updateMyProfile(
  updatedProfile: Partial<CamelCasedObject<RAuthProfileAPIResponse>>
) {
  try {
    const response = await authFetcher.post<
      CamelCasedObject<RAuthProfileAPIResponse>
    >(AuthEndpoints.updateProfile, updatedProfile);

    return response?.data?.data;
  } catch (error) {
    console.error('Failed to update profile:', error);
    throw new Error('Unable to update profile. Please try again later.');
  }
}
